// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"360":"9259e280db77aa0cd7c4","600":"68da3213b1921d46c5a8"}[chunkId] + ".bundle.js";
};